export enum ContractEngagementTraceabilityStatus {
  Creation = 'En création',
  SignedBeneficiary = 'Signé bénéficiaire',
  ValidatedTerritory = 'Validé Territoire',
  SignedTerritory = 'Signé Territoire',
  Unvalidated = 'Invalidé - Retour référent',
  ValidatedDie = 'Validé DIE',
  SignedDie = 'Signé DIE',
  Done = 'Terminé',
}
